import React from 'react'
import FontAwesome from 'react-fontawesome'
import { Button, FormControl } from 'react-bootstrap'
import moment from 'moment'
import classNames from 'classnames'

import DateInput from './DateInput'
import PeriodInput, { getPeriodString } from './PeriodInput'
import RevisionsPopup from './RevisionsPopup'
import ContentReferenceInput, { listToString } from './ContentReferenceInput'
import { DropdownList } from 'react-widgets'

class PropertyInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = { value: props.value, readonly: true }
  }

  onChange(value) {
    if (value && value.id === -1) {
      this.setState({ value: null })
    } else {
      this.setState({ value })
    }
  }

  onSave() {
    this.setState({ readonly: true })
    this.props.onSave(this.props.property, this.state.value)
  }

  getValueElement() {
    if (this.state.readonly) {
      let label
      switch (this.props.type) {
        case 'date':
          label = this.props.value ? moment(this.props.value).format('DD-MM-YYYY') : ''
          break
        case 'choice':
          label = this.props.value ? this.props.value.name : ''
          break
        case 'period':
          label = this.props.value ? getPeriodString(this.props.value) : ''
          break
        case 'content-references':
          label = this.props.value ? listToString(this.props.value) : ''
          break
        default:
          label = this.props.value || ''
      }
      return label
    } else {
      switch (this.props.type) {
        case 'text':
          return (
            <FormControl
              type="text"
              className="input-text"
              autoFocus
              value={this.state.value ? this.state.value : ''}
              onChange={(e) => this.onChange(e.target.value)}
            />
          )
        case 'number':
          return (
            <FormControl
              type="number"
              className="input-text"
              autoFocus
              value={this.state.value ? this.state.value : ''}
              onChange={(e) => this.onChange(e.target.value)}
            />
          )
        case 'date':
          return <DateInput value={this.state.value} onChange={(value) => this.onChange(value)} />
        case 'period':
          return <PeriodInput value={this.state.value} onChange={(value) => this.onChange(value)} />
        case 'content-references':
          return <ContentReferenceInput value={this.state.value} onChange={(value) => this.onChange(value)} />
        case 'choice':
          return (
            <DropdownList
              placeholder="Kies een waarde"
              textField="name"
              data={this.props.choices}
              defaultValue={this.props.value}
              onChange={(value) => {
                this.onChange(value)
                // Auto-save and close for choice fields
                setTimeout(() => this.onSave(), 0)
              }}
              open={true}
              onToggle={() => {}}
            />
          )
        default:
          return <span />
      }
    }
  }

  getButtonsElement() {
    if (!this.props.disabled) {
      if (this.state.readonly) {
        return (
          <div className="buttons">
            {this.props.entity ? <RevisionsPopup {...this.props} /> : <span />}
            <FontAwesome
              name="pencil"
              size="lg"
              onClick={() => this.setState({ readonly: false })}
              id={`edit-${this.props.property}`}
            />
          </div>
        )
      } else {
        return (
          <div className="buttons">
            <Button id={`save-${this.props.property}`} className="save-property" onClick={() => this.onSave()}>
              Opslaan
            </Button>
          </div>
        )
      }
    } else {
      return <span id={`disabled-${this.props.property}`}></span>
    }
  }

  render() {
    let valueElement = this.getValueElement()
    let buttonsElement = this.getButtonsElement()

    return (
      <div
        className={classNames(
          'property-input',
          { [`${this.props.className}`]: this.props.className !== undefined },
          [`type-${this.props.type}`],
          { 'edit-mode': !this.state.readonly }
        )}
      >
        <div className="input-header">
          <FontAwesome name={this.props.icon} size="lg" /> {this.props.label}
          {buttonsElement}
        </div>
        <span className="value" id={`value-${this.props.className}`}>
          {valueElement}
        </span>
      </div>
    )
  }
}

export default PropertyInput
